import { Tooltip, TooltipProps } from '@mui/material';

import { TypographyStyled } from './TooltipTypography.styled';

export const TooltipTypography = ({ children, title, ...props }: TooltipProps) => {
  return (
    <Tooltip
      {...props}
      title={
        <TypographyStyled variant="body2" sx={{ whiteSpace: 'pre-line' }}>
          {title}
        </TypographyStyled>
      }
    >
      {children}
    </Tooltip>
  );
};
